import useStore from "stores/index";
import { ClassroomOverviewDTO } from "stores/classroomStore_I";

function checkIsInSession(expiry: number) {
	if (expiry > Date.now() / 1000) {
		return true;
	}
	return false;
}

export function checkForActiveMonitoringSession(): ClassroomOverviewDTO | undefined {
	const classrooms = useStore.getState().classroom.getClassrooms();
	const activeMonitoringSession = classrooms.find(
		(c) => c.session?.isMonitoring && c.session?.sessionEndTime && checkIsInSession(c.session?.sessionEndTime)
	);

	// There should only be one other active monitoring classroom, if not then there is bug.
	return activeMonitoringSession;
}
